// =============================================================================
// ORBS DATA
// =============================================================================
// Data for the 7 orbs in the boot sequence ring
// First orb is the profile/photo, rest are projects
// Single source of truth for tooltip, idle Z3, and peek Z3

export interface OrbData {
  id: string;
  type: "profile" | "project";
  // Content fields (unified for tooltip/idle/peek)
  category?: string;
  headline: string;
  subhead: string;
  eyebrow?: string;
  tags?: string[];
  slug?: string;
  // Visual fields
  color: string;
  icon: string;
  thumbnail?: string;
}

export const ORBS_DATA: OrbData[] = [
  {
    id: "profile",
    type: "profile",
    headline: "Vincent Ngu",
    subhead: "Product Designer",
    color: "#FFFFFF", // Neutral white
    icon: "/images/profile.webp",
  },
  // Ring/strip sort: left = recent, right = old (V 2026-08-06). csc (2026) is
  // the newest work, so it leads the project orbs.
  {
    id: "csc",
    type: "project",
    category: "Accessibility",
    headline: "Making Subtitles Work for Everyone",
    subhead:
      "Designing Crunchyroll’s in-player subtitle & captions customization for Deaf and low vision fans",
    eyebrow: "Crunchyroll • Nov 2025–Present",
    // First tag is the ROLE on every project orb (see orbs.test.ts) — V was
    // Design Lead for the sprint, not sprint lead (V ruling 2026-09-27).
    tags: ["Design Lead", "Co-Design Research", "In-Player Subtitles", "Live Prototype"],
    slug: "csc",
    color: "#0EA5E9", // Sky blue — distinct from the orange CR + green Panera orbs
    icon: "/images/icon/CSC-Icon.webp",
    // thumbnail: TODO(V) — add /images/orbs/ids.jpg for the peek card art
  },
  {
    id: "vpr",
    type: "project",
    category: "Cross-Platform",
    headline: "Rebuilding Playback For Millions of Fans",
    subhead: "Designing Crunchyroll's video player across web, mobile, and living room",
    eyebrow: "Crunchyroll • 2024–Present",
    tags: ["Solo Designer", "8 Platforms", "24+ Sprints", "~1% Playback Failure"],
    slug: "vpr",
    color: "#E03C00", // Orange-red
    icon: "/images/icon/VPR-Icon.webp",
    thumbnail: "/images/orbs/vpr.jpg",
  },
  {
    id: "avp",
    type: "project",
    category: "0▸1 Platform",
    headline: "Bringing Anime to Spatial Computing",
    subhead: "Designing Crunchyroll for Apple Vision Pro",
    eyebrow: "Crunchyroll • Dec 2023–Feb 2024",
    tags: ["Solo Designer", "Day 1 Launch", "1.5 Months", "Featured App Store", "4.8★ Rating"],
    slug: "avp",
    color: "#FF5E00", // Orange
    icon: "/images/icon/AVP-Icon.webp",
    thumbnail: "/images/orbs/avp.jpg",
  },
  {
    id: "cmp",
    type: "project",
    category: "Living Room",
    headline: "Enabling Household Anime Sharing",
    subhead: "Designing Crunchyroll's Profile System",
    eyebrow: "Crunchyroll • Q4 2023–April 2024",
    tags: ["LRX Design Lead", "4M+ Profiles", "80% Active", "73% Above Goal", "95.8% Success Rate"],
    slug: "cmp",
    color: "#F97316", // Warm orange
    icon: "/images/icon/MP-Icon.webp",
    thumbnail: "/images/orbs/cmp.jpg",
  },
  {
    id: "esr",
    type: "project",
    category: "Recommendations",
    headline: "Turning Post-Show Moments Into Discovery",
    subhead: "Designing Crunchyroll's End Slate Recommendations System",
    eyebrow: "Crunchyroll • May 2024–March 2025",
    tags: ["Design Lead", "692M Minutes Watched", "34M Video Plays", "10M Users"],
    slug: "esr",
    color: "#FF9500", // Light orange / golden
    icon: "/images/icon/ESR-Icon.webp",
    thumbnail: "/images/orbs/esr.jpg",
  },
  {
    id: "rr",
    type: "project",
    category: "Mobile",
    headline: "Streamlining On-the-Go Ordering",
    subhead: "Designing Panera Bread's Rapid Reorder Feature",
    eyebrow: "Panera Bread • Dec 2018–Jan 2019",
    tags: ["Solo Designer", "$3M+ Revenue", "4.8★ Satisfaction", "260K+ Orders", "Featured App Store"],
    slug: "panera-mobile",
    color: "#3A9656", // Green
    icon: "/images/icon/RR-Icon.webp",
    thumbnail: "/images/orbs/rr.jpg",
  },
  {
    id: "vux",
    type: "project",
    category: "Voice + Multi-Modal",
    headline: "Pioneering Voice Ordering",
    subhead: "Designing Panera Bread's Voice Assistants",
    eyebrow: "Panera Bread • 2017 (Google) • 2019 (Amazon)",
    tags: ["Solo Designer", "Google I/O 2017", "1st QSR Voice", "Amazon 2019 Launch", "5★ Alexa Reviews"],
    slug: "panera-voice",
    color: "#14B8A6", // Teal
    icon: "/images/icon/VUX-Icon.webp",
    thumbnail: "/images/orbs/vux.jpg",
  },
];
